import React from 'react'

import CheckoutPayment from './views/CheckoutPayment/CheckoutPayment'
import CheckoutPaymentPis from './views/CheckoutPayment/CheckoutPaymentPis'

const LazyAuth = React.lazy(() => import('./views/WalletLogin'))
const LazyCheckoutFailure = React.lazy(() => import('./views/CheckoutFailure/CheckoutFailure'))
const LazyCheckoutFailurePis = React.lazy(() => import('./views/CheckoutFailure/CheckoutFailurePis'))
const LazyCheckoutPolling = React.lazy(() => import('./views/CheckoutPolling/CheckoutPolling'))
const LazyCheckoutPollingPis = React.lazy(() => import('./views/CheckoutPolling/CheckoutPollingPis'))
const LazyCheckoutSuccess = React.lazy(() => import('./views/CheckoutSuccess/CheckoutSuccess'))
const LazyCheckoutSuccessPis = React.lazy(() => import('./views/CheckoutSuccess/CheckoutSuccessPis'))

const routes = [
  { path: '/auth/sessionId/:sessionId', component: LazyAuth },
  { path: '/auth', component: LazyAuth },

  { path: '/error', component: React.lazy(() => import('./views/CheckoutError')) },

  { path: '/pis/fail/sessionId/:sessionId/lang/:languageCode', component: LazyCheckoutFailurePis },
  { path: '/pis/fail/sessionId/:sessionId', component: LazyCheckoutFailurePis },
  { path: '/pis/fail', component: LazyCheckoutFailurePis },

  { path: '/pis/success/sessionId/:sessionId/lang/:languageCode', component: LazyCheckoutSuccessPis },
  { path: '/pis/success/sessionId/:sessionId', component: LazyCheckoutSuccessPis },
  { path: '/pis/success', component: LazyCheckoutSuccessPis },

  { path: '/pis/processing/sessionId/:sessionId/lang/:languageCode', component: LazyCheckoutPollingPis },
  { path: '/pis/processing/sessionId/:sessionId', component: LazyCheckoutPollingPis },
  { path: '/pis/processing', component: LazyCheckoutPollingPis },

  { path: '/pis/sessionId/:sessionId/lang/:languageCode', exact: true, component: CheckoutPaymentPis },
  { path: '/pis/sessionId/:sessionId', exact: true, component: CheckoutPaymentPis },
  { path: '/pis', exact: true, component: CheckoutPaymentPis },

  { path: '/fail/sessionId/:sessionId/lang/:languageCode', component: LazyCheckoutFailure },
  { path: '/fail/sessionId/:sessionId', component: LazyCheckoutFailure },
  { path: '/fail', component: LazyCheckoutFailure },

  { path: '/success/sessionId/:sessionId/lang/:languageCode', component: LazyCheckoutSuccess },
  { path: '/success/sessionId/:sessionId', component: LazyCheckoutSuccess },
  { path: '/success', component: LazyCheckoutSuccess },

  { path: '/processing/sessionId/:sessionId/lang/:languageCode', component: LazyCheckoutPolling },
  { path: '/processing/sessionId/:sessionId', component: LazyCheckoutPolling },
  { path: '/processing', component: LazyCheckoutPolling },

  { path: '/sessionId/:sessionId/lang/:languageCode', exact: true, component: CheckoutPayment },
  { path: '/sessionId/:sessionId', exact: true, component: CheckoutPayment },
  { path: '/', exact: true, component: CheckoutPayment },

  { path: '*', redirect: '/' }
]

export default routes
